<template lang='pug' src='./home.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Hero from 'components/hero/hero-home/hero-home'
import BlockText from 'components/block/block-text/block-text'
import BlockCta from 'components/block/block-cta/block-cta'
import TabsHome from 'components/tabs/tabs-home/tabs-home'
import SliderTestimonials from 'components/slider/slider-testimonials/slider-testimonials'
import TabsMap from 'components/tabs/tabs-map/tabs-map'
import BlockContact from 'components/block/block-contact/block-contact'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    Hero,
    BlockText,
    BlockCta,
    TabsHome,
    SliderTestimonials,
    TabsMap,
    BlockContact
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?618b746e